<template>
  <div>
    <h3>You're all done</h3>
    <br/>
    <p>
      Thank you for completing a new area of interest.
    </p>
    <p>
      You're good to go. Click the "Finish" button below to complete the
      process.
    </p>

    <div class="clearfix"></div>

    <button class="ts-btn ts-btn-rounded ts-btn-secondary" @click="submitSga()">
      Finish
    </button>
  </div>
</template>

<script>
export default {
  created() {},
  destroyed() {},
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    },
  },
  methods: {
    submitSga() {
        
      this.$router.push({ name: 'UserInterestsLanding' });
    },
  },
};
</script>